import './form.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import InputField from '../../shared/form-elements/input';
import Checkbox from '../../shared/form-elements/checkbox';

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	submitForm,
	editId,
	intl
}) => (
	<div className="form-container landing-snippets-form">
		<div className="form-container__head">
			<h2>{ intl(!editId ? 'Create new landing metric' : 'Edit landing metric') }</h2>
		</div>
		<div className="form-container__body">
			<form className="ui-form create-parking-domain" onSubmit={handleSubmit(data => submitForm(data, editId))}>

				<div className="ui-form__element">
					<Field name="name" placeholder={ intl('Name') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="external_id" placeholder={ intl('External Id') } component={InputField} />
				</div>

				<div className="ui-form__element">
					<Field name="is_dangerous" placeholder={ intl('Is dangerous') } component={Checkbox} />
				</div>

				<div className="ui-form__element">
					<button className="ui-btn ui-btn-primary">{ intl(!editId ? 'Save' : 'Edit') }</button>
					<Link to="landing-snippets/">
						<button type="button" className="ui-btn ui-btn-cancel">
							{intl('Cancel')}
						</button>
					</Link>
				</div>
			</form>
		</div>
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	submitting: PropTypes.bool,
	submitForm: PropTypes.func,
	editId: PropTypes.any,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'landingSnippets-Form'
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/landing-snippets/components/form.js